// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)


export default new Vuetify({
theme: {
    themes: {
        light: {
            salmonOrange: '#ff9a8d', // #E53935
            customGrey: '#4a536b', // #E53935
        },
    },
    },
})


// WEBPACK FOOTER //
// ./src/plugins/vuetify.js